import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { equipmentListFilterFields } from '@/features/equipment/equipmentListFilterFields';
export const EquipmentTableFilterSchema = z.object({
  ...dataGridSearchFields,
  ...equipmentListFilterFields
});
export type EquipmentTableFilter = z.infer<typeof EquipmentTableFilterSchema>;